var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('channel-edit',{attrs:{"loading":_vm.loading,"new-article":true},on:{"save-channel":_vm.saveChannel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }